module.exports = __webpack_public_path__ + "media/images/armoiries-c0f8b48c22ec026db20b085e36d585fa.png";